import React from 'react';
import { Button } from '@/components/ui';
import { Mail } from 'lucide-react';
import { ProfileApiResponse } from '@/lib/api/services/admin-user';

type AdminUser = ProfileApiResponse[0];

interface ResendInviteModalProps {
  isOpen: boolean;
  member: AdminUser;
  onClose: () => void;
  onConfirm: () => void;
  isProcessing?: boolean;
}

const ResendInviteModal: React.FC<ResendInviteModalProps> = ({
  isOpen,
  member,
  onClose,
  onConfirm,
  isProcessing = false,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="Resend invite confirmation"
    >
      <div className="m-4 w-full max-w-lg rounded-xl bg-white shadow-lg" onClick={(e) => e.stopPropagation()}>
        <div className="p-8 text-center">
          <div className="mx-auto mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-emerald-100">
            <Mail className="h-10 w-10 text-emerald-700" />
          </div>

          <h2 className="text-2xl font-bold text-gray-800">Resend Invite?</h2>
          <p className="mx-auto mt-2 max-w-sm text-sm text-gray-500">
            Are you sure you want to resend an invite to {member.firstName} {member.lastName}?
          </p>
          <p className="mx-auto mt-1 max-w-sm text-sm text-gray-500">A new invite email will be sent to {member.emailAddress}.</p>

          <div className="mt-8 flex justify-center gap-4">
            <Button variant="primary" onClick={onConfirm} disabled={isProcessing}>
              {isProcessing ? 'Sending...' : 'Resend Invite'}
            </Button>
            <Button variant="secondary" onClick={onClose} disabled={isProcessing}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResendInviteModal;